import type { SharedInfraRow } from '../../repositoryblueprint/framework';

type Props = { items?: SharedInfraRow[] };

export function SharedInfraConfigPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.category} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.category}</p>
            <p className="text-lg font-semibold text-brand-600">{item.items}</p>
          </div>
          <p className="mt-1 font-mono text-xs text-slate-500">{item.path}</p>
          <span className="mt-1 inline-block rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">
            {item.status}
          </span>
        </div>
      ))}
    </div>
  );
}
